import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { CommandeLine } from "./commande-line";
import { BasketService } from "./basket.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class BasketResolver {
    constructor(
        private basketService: BasketService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<CommandeLine>> {
        return this.basketService.getBasket();
    }
}
